export default "__VITE_ASSET__B29vSHQF__"